import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Dashboard from "./Screens/Dashboard.js";
import AppAppBar from "./components/AppAppBar.js";
import SearchPage from "./Screens/SearchPage.js";
import AppTheme from "./shared-theme/AppTheme";
import Footer from "./components/Footer.js";
import SignInSide from "./Screens/Auth/SignInSide.js";
import SignUpSide from "./Screens/Auth/SignUpSide.js";
import CreatorDetail from "./Screens/Creator/CreatorDetail.js";
import BrandProfileRoute from "./Routes/BrandProfileRoute.js";
import CreatorProfileRoute from "./Routes/CreatorProfileRoute.js";
import ResetPassword from "./Screens/Auth/ResetPassword.js";
import ChangePassword from "./Screens/Auth/ChangePassword.js";
import ChatBotPage from "./Screens/ChatBot/ChatBotPage.js";
import LiveSearchPage from "./Screens/LiveSearchPage.js";
import FeaturesPage from "./Screens/Static/FeaturesPage.js";
import HighlightsPage from "./Screens/Static/HighlightsPage.js";
import FAQPage from "./Screens/Static/FAQPage.js";
import AboutPage from "./Screens/Static/AboutPage.js";
import CareersPage from "./Screens/Static/CareersPage.js";
import PressPage from "./Screens/Static/PressPage.js";
import TermsPage from "./Screens/Static/TermsPage.js";
import PrivacyPage from "./Screens/Static/PrivacyPage.js";
import ContactPage from "./Screens/Static/ContactPage.js";
function App(props) {
  return (
    <AppTheme {...props}>
      <Router>
        <AppAppBar />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/sign-in" element={<SignInSide />} />
          <Route path="/sign-up" element={<SignUpSide />} />
          <Route path="/creator/:id" element={<CreatorDetail />} />
          <Route path="/brand-profile" element={<BrandProfileRoute />} />
          <Route path="/influencer-profile" element={<CreatorProfileRoute />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/Chat-Bot" element={<ChatBotPage />} />
          <Route path="/live-search" element={<LiveSearchPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/highlights" element={<HighlightsPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </Router>
    </AppTheme>
  );
}

export default App;
